import { IGetSubcontasDropDownUseCase } from "../../../presentation/useCases/read/get_subcontas_dropdown_use_case";
import { SubcontaDropdown } from "../../models/subconta_dropdown";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetSubcontasDropDownUseCase
 */

export class GetSubcontasDropDownUseCase implements IGetSubcontasDropDownUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getSubcontasDropDown(): Promise<SubcontaDropdown[]> {
    return await this.repository.getSubcontasDropDown();
  }
}
